import { __extends } from "tslib";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { noop } from 'lodash-es';
import { Orientation } from '@marvelapp/core';
import { isIOS } from '../utils/deviceDetection';
var DeviceOrientation = /** @class */ (function (_super) {
    __extends(DeviceOrientation, _super);
    function DeviceOrientation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOrientationChange = function () {
            var orientationChanged = _this.props.orientationChanged;
            fixMobileSafariHeight();
            var currentOrientation = getScreenOrientation();
            orientationChanged(currentOrientation);
        };
        return _this;
    }
    DeviceOrientation.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onOrientationChange);
        window.addEventListener('orientationchange', this.onOrientationChange);
        this.onOrientationChange();
    };
    DeviceOrientation.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onOrientationChange);
        window.removeEventListener('orientationchange', this.onOrientationChange);
    };
    DeviceOrientation.prototype.render = function () {
        return null;
    };
    DeviceOrientation.propTypes = {
        orientationChanged: PropTypes.func.isRequired,
    };
    DeviceOrientation.defaultProps = {
        orientationChanged: noop,
    };
    return DeviceOrientation;
}(Component));
export default DeviceOrientation;
function getScreenOrientation() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation
    // Not supported in Safari, and some older browsers, so won't cover all cases
    /* eslint-disable no-restricted-globals */
    if (screen.orientation) {
        return /landscape/i.test(screen.orientation.type)
            ? Orientation.Landscape
            : Orientation.Portrait;
        // Deprecated, but still supported by some browsers
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/orientation
        // We need this for iOS 11, because the fallback below does not work in it
    }
    if (window.orientation !== undefined) {
        return Math.abs(window.orientation) === 90
            ? Orientation.Landscape
            : Orientation.Portrait;
    }
    // If `screen.orientation` and `window.orientation` are not available,
    // fallback to checking window width and height
    return window.innerHeight > window.innerWidth
        ? Orientation.Portrait
        : Orientation.Landscape;
}
// This is hack for Mobile Safari 13+. 🤷🏻‍♂️
// When rotating from landscape to portrait a white space appears on the bottom
// of the screen and Safari does show the bottom navigation bar.
// See https://stackoverflow.com/questions/62717621/
// Calling window.scrollTo forces a repaint, updating the height, but the problem
// is that the orientationchange event is fired during the rotation transition,
// so we need to add some arbitrary timeouts to (hopefully) update the height
// once the animation is completed.
function fixMobileSafariHeight() {
    if (!isIOS)
        return;
    setTimeout(function () {
        window.scrollTo(0, 1);
    }, 250);
    setTimeout(function () {
        window.scrollTo(0, 1);
    }, 500);
}
